<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
    </div>
</template>

<script>
    export default {
        name: 'CellRendererActions',
        methods: {
          
          confirmDeleteRecord() {
            console.log(this.params.data)
            this.$vs.dialog({
              type: 'confirm',
              color: 'danger',
              title: `Confirmation de la suppression `,
              text: `Vous êtes sur le point de supprimer "${this.params.data.nom} ${this.params.data.prenom}"`,
              accept: this.deleteRecord,
              acceptText: "supprimer"
            })
          },
          deleteRecord() {
            /* Below two lines are just for demo purpose */
            //this.showDeleteSuccess()
            this.$store.dispatch("classe/removeParticipationCandidatFormation",this.params.data).then(()   => { this.showDeleteSuccess() }).catch(err => { console.error(err);this.showDeleteeror()       })

            
            /* UnComment below lines for enabling true flow if deleting user */
            // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
            //   .then(()   => { this.showDeleteSuccess() })
            //   .catch(err => { console.error(err)       })
          },
          showDeleteeror() {
            this.$vs.notify({
              color: 'danger',
              title: 'Candidat pas supprimé',
              text: 'Candidat sélectionné pas supprimé'
            })
            
          },
          showDeleteSuccess() {
            this.$vs.notify({
              color: 'success',
              title: 'Candidat supprimé',
              text: 'Candidat sélectionné a été supprimé avec succès'
            })
            
          },
          showDeleteeror() {
            this.$vs.notify({
              color: 'dnager',
              title: 'Candidat supprimé',
              text: 'Candidat sélectionné a été supprimé avec succès'
            })
            
          },
        }
    }
</script>
